export default __webpack_public_path__ + "static/media/news2.b166e5e8.jpg";